import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
// @ts-ignore
import VueMeta from 'vue-meta'
import VueI18n from 'vue-i18n'
// @ts-ignoreline
import VueAppInsights from 'vue-application-insights'
import { APPLICATION_INSIGHTS } from './const'
import { languages } from './lang/index'
import { defaultLocale } from './lang/index'

const INSTRUMENTATION_KEY = process.env.NODE_ENV === 'production'
  ? APPLICATION_INSIGHTS.INSTRUMENTATION_KEY_PROD : APPLICATION_INSIGHTS.INSTRUMENTATION_KEY_DEV

Vue.use(VueAppInsights, {
  baseName: 'cf247-application-form',
  id: INSTRUMENTATION_KEY,
  router,
  appInsightsConfig: {
    instrumentationKey: INSTRUMENTATION_KEY,
    disableFetchTracking: false,
    enableCorsCorrelation: false,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    enableAutoRouteTracking: true,
    enableAjaxErrorStatusText: true,
    enableAjaxPerfTracking: true
  }
}).use(VueMeta, {
	// optional pluginOptions
	refreshOnceOnNavigation: true
}).use(VueI18n)

const messages = Object.assign(languages);

const i18n = new VueI18n({
	locale: defaultLocale,
	messages
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
	i18n,
  render: h => h(App)
}).$mount('#app')
